<template>
  <div v-loading="loading" class="dwPzvipBody">
    <div
      style="
            float: right;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
          "
      @click="back"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div class="_title">
      <p class="_title_info">单位分配等级</p>
    </div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="单位名称：" prop="dwmc">
        <el-input v-model="searchForm.dwmc" />
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="shtyxydm">
        <el-input v-model="searchForm.shtyxydm" />
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 搜 索 </el-button>
      </div>
    </el-form>
    <el-descriptions v-if="localData" class="descriptions" title="查询结果" :column="2" :labelStyle='labelStyle' border>
      <el-descriptions-item >
        <template slot="label">
          <i class="el-icon-office-building" />
          单位名称
        </template>
        {{ localData.dwmc }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          信用代码
        </template>
        {{ localData.shtyxydm }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          当前等级
        </template>
        {{ localData.vipLevel == 0?'系统默认': localData.vipLevel}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          到期日期
        </template>
        {{ localData.vipGqsj}}
      </el-descriptions-item>
      <el-descriptions-item v-if="localData.wqyId != null">
        <template slot="label">
          <i class="el-icon-office-building" />
          等级（暂未启用）
        </template>
        {{localData.wqyVipLevel}}
      </el-descriptions-item>
      <el-descriptions-item v-if="localData.wqyId != null">
        <template slot="label">
          <i class="el-icon-office-building" />
          到期日期（暂未启用）
        </template>
        {{localData.wqyVipGqsj}}
      </el-descriptions-item>
    </el-descriptions>

    <el-dialog v-loading="loading" title="修改单位配置" :visible.sync="updFlag">
      <el-form :model="upddto" label-width="150px">
        <el-form-item label="等级" >
          <el-select
            style="width: 80%"
            v-model="upddto.level"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in vipList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="到期日期">
          <el-date-picker
            style="width: 80%"
            v-model="upddto.endTime"
            :picker-options="pickerBeginDateAfter"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updFlag = false">取 消</el-button>
        <el-button type="primary" @click="updSave">确 定</el-button>
      </div>
    </el-dialog>
    <div class="buttonList" style="width: 25%;"  v-if="localData">
      <el-button type="success" @click="updLoad"> 修 改 </el-button>
      <el-button :disabled="localData.wqyId != null?false:true" type="danger"  @click="delDwVip"> 删 除 </el-button>
    </div>
    <div v-if="localData">
      <h3>历史配置记录</h3>
      <div class="tablemes">
        <el-table
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="vipLevel"
            label="等级"
          />
          <el-table-column
            prop="cjsj"
            label="配置时间"
          />
          <el-table-column
            prop="endTimeRQ"
            label="过期日期"
          />
          <el-table-column
            label="生效时间"
          >
            <template slot-scope="scope">
              {{scope.row["status"] == '0'?'':scope.row["gxsj"]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="statusLabel"
            width="120px"
            label="状态"
          />
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <div style="margin:0 auto;font-size: 15px;" v-if="localData">
      <p style="color:red;font-weight: bold;">配置提示：</p>
      <p>1.修改等级配置后，属于未启用配置（等级和到期日期）；</p>
      <p>2.暂未启用的等级配置可以修改和删除；</p>
      <p>3.未启用配置在配置后凌晨才会生效，请告知用户凌晨不要操作业务；</p>
      <p>4.不支持存在有效等级时，将其降级；</p>
    </div>
  </div>
</template>

<script>
import { getDwVipxx,getVipLevels,updDwVipSave,removeDwVip } from '@/assets/js/system.js'
import { isEmpty} from "@/utils/tool";
import {getDwVipRecordList} from "@/assets/js/system";
export default {
  props: ['nowDwmc', 'vipList'],
  data() {
    return {
      dwVipLevel:'',
      loading: false,
      updFlag: false,
      searchForm: {
        dwmc: '',
        shtyxydm: ''
      },
      upddto: {
        level: '',
        endTime: ''
      },
      localData: false,
      labelStyle:{'width' : '200px'},
      pickerBeginDateAfter: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      tableData:[],
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
    }
  },
  mounted(){
    this.searchForm.dwmc = this.nowDwmc
    if(!isEmpty(this.searchForm.dwmc)){
      this.submit()
    }
  },
  methods: {
    reset() {
      this.searchForm = { dwmc: '', shtyxydm: '' }
      this.localData = false
    },
    getHistRecord(){
      getDwVipRecordList({
        page: this.currentPage,
        size: this.pagesize,
        param: {}
      },this.localData.id).then((e) => {
        if(e.status == 200){
          this.tableData = e.data.data.rows
          this.total = e.data.data.total
        }
      })
    },
    submit() {
      if (!this.searchForm.shtyxydm && !this.searchForm.dwmc) {
        this.$message('单位名称与统一信用代码必填一个')
        return
      }
      this.loading = true
      getDwVipxx(this.searchForm)
        .then((e) => {
          this.loading = false
          this.localData = e.data.data
          this.updFlag = false
          this.getHistRecord()
        })
        .catch(() => {
          this.loading = false
        })
    },
    updLoad(){
      this.updFlag = !this.updFlag
      this.upddto.level = ''
      this.upddto.endTime = ''
      if(this.localData.wqyId != null){
        this.upddto.level = this.localData.wqyVipLevel
        this.upddto.endTime = this.localData.wqyVipGqsj
      }else if(this.localData.vipLevel != 0){
        this.upddto.level = this.localData.vipLevel
        this.upddto.endTime = this.localData.vipGqsj
      }
    },
    delDwVip(){
      this.$confirm('此操作将删除未启用的单位等级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        removeDwVip(this.localData.id,this.localData.wqyId).then((e) => {
          this.$message.success('删除成功')
          this.submit()
        }).catch(() => {
          this.loading = false
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    updSave(){
      if(!this.upddto.level && !this.upddto.endTime){
        this.$message('请选择单位等级和到期日期')
        return
      }
      this.$confirm('此操作将修改单位的等级信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updDwVipSave(this.localData.id,this.upddto).then((e) => {
          this.$message.success('修改成功')
          this.loading = true
          this.submit()
        }).catch(() => {
          this.loading = false
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
    back() {
      this.$parent.nowDwmc = ''
      this.$parent.pupopShow = false
      this.$parent.loadDatasource()
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getHistRecord()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getHistRecord()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
  }
}
</script>

<style lang='less' scoped>
.dwPzvipBody {
  padding: 20px;
  background-color: white;
  margin: 10px;
  min-height: 800px;
  width: 80%;
  margin-left: 10%;
  ._title {
    /*margin-top: 50px;*/
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px auto 0px auto;
    width: 50%;
  }
}
.descriptions {
    width: 70%;
    margin: 0 auto;;
}
</style>
